import { rootApi } from "../../api/rootApi";

const auth = (token) => ({ "Content-Type": "application/json", Authorization: "Bearer " + token });

export const onboardingApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    listOnboarding: builder.query({
      query: ({ token, status }) => ({
        method: "GET",
        url: `/admin/onboarding${status ? `?status=${status}` : ""}`,
        headers: auth(token),
      }),
    }),
    getOnboarding: builder.query({
      query: ({ token, id }) => ({ method: "GET", url: `/admin/onboarding/${id}`, headers: auth(token) }),
    }),
    createOnboarding: builder.mutation({
      query: ({ token, body }) => ({ method: "POST", url: "/admin/onboarding", headers: auth(token), body: JSON.stringify(body) }),
    }),
    updateOnboarding: builder.mutation({
      query: ({ token, id, body }) => ({ method: "PUT", url: `/admin/onboarding/${id}`, headers: auth(token), body: JSON.stringify(body) }),
    }),
    deleteOnboarding: builder.mutation({
      query: ({ token, id }) => ({ method: "DELETE", url: `/admin/onboarding/${id}`, headers: auth(token) }),
    }),
  }),
});

export const {
  useListOnboardingQuery,
  useLazyGetOnboardingQuery,
  useCreateOnboardingMutation,
  useUpdateOnboardingMutation,
  useDeleteOnboardingMutation,
} = onboardingApi;
